// Dependecies
import React from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'react-bootstrap/Tooltip';

function RenderTooltip(props) {
  const {
    src,
    text,
    id,
    classtxt,
    classImage,
    text2,
    text3,
    brand,
    model,
    color,
    items,
    alt,
    unique,
  } = props;
  return (
    <Tooltip id={id} {...props}>
      {src ? <img className={classImage} src={src} alt={alt} /> : ''}
      {text && text2 && text3 && brand && model && color ? (
        <>
          <div className="body-tooltip">
            <p className="txt-tooltip-title">{text}</p>
            <p className="txt-tooltip-vehicle">{brand}</p>
            <p className="txt-tooltip-title">{text2}</p>
            <p className="txt-tooltip-vehicle">{model}</p>
            <p className="txt-tooltip-title">{text3}</p>
            <p className="txt-tooltip-vehicle">{color}</p>
          </div>
        </>
      ) : (
        ''
      )}

      {text && unique ? <p className={classtxt}>{text}</p> : ''}

      {items && items.length > 1 ? (
        <>
          {items.map((item) => (
            <li className="li-type-services"> {item} </li>
          ))}
        </>
      ) : (
        ''
      )}
    </Tooltip>
  );
}

RenderTooltip.propTypes = {
  src: PropTypes.string,
  id: PropTypes.string,
  classtxt: PropTypes.string,
  classImage: PropTypes.string,
  text: PropTypes.string,
  text2: PropTypes.string,
  text3: PropTypes.string,
  brand: PropTypes.string,
  model: PropTypes.string,
  color: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  alt: PropTypes.string,
  unique: PropTypes.bool,
};

RenderTooltip.defaultProps = {
  src: '',
  text: '',
  id: '',
  classtxt: '',
  classImage: '',
  text2: '',
  text3: '',
  brand: '',
  model: '',
  color: '',
  alt: '',
  unique: false,
};

export default RenderTooltip;
